"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Select = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var styles = {
  "Select__wrapper": "Select__Select__wrapper___2mbYV",
  "Select": "Select__Select___2Gi9N a11y__focus-border--default___60AXp",
  "Select--disabled": "Select__Select--disabled___156vR",
  "Select--small": "Select__Select--small___2amb5",
  "Select--medium": "Select__Select--medium___1QRqZ",
  "Select--large": "Select__Select--large___1HaJb",
  "Select--full": "Select__Select--full___AENS4",
  "Select--auto": "Select__Select--auto___3Y-B9",
  "Select--negative": "Select__Select--negative___1lj8S",
  "Select__icon": "Select__Select__icon___OBmvS"
};
var defaultProps = {
  testId: 'cf-ui-select',
  required: false,
  hasError: false,
  isDisabled: false,
  width: 'full',
  willBlurOnEsc: true
};

var Select = function Select(props) {
  var _cn;

  var id = props.id,
      name = props.name,
      required = props.required,
      children = props.children,
      width = props.width,
      className = props.className,
      testId = props.testId,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      isDisabled = props.isDisabled,
      hasError = props.hasError,
      value = props.value,
      willBlurOnEsc = props.willBlurOnEsc,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["id", "name", "required", "children", "width", "className", "testId", "onChange", "onBlur", "onFocus", "isDisabled", "hasError", "value", "willBlurOnEsc"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      valueState = _useState2[0],
      setValueState = _useState2[1];

  var handleKeyDown = function handleKeyDown(e) {
    if (e.nativeEvent.code === 'Escape' && willBlurOnEsc) {
      e.currentTarget.blur();
    }
  };

  var handleChange = (0, _react.useCallback)(function (e) {
    if (!isDisabled) {
      setValueState(e.target.value);

      if (onChange) {
        onChange(e);
      }
    }
  }, [onChange, isDisabled]);
  (0, _react.useEffect)(function () {
    setValueState(value);
  }, [value]);
  var widthClass = "Select--".concat(width);
  var classNames = (0, _classnames["default"])(styles['Select'], (_cn = {}, (0, _defineProperty2["default"])(_cn, styles['Select--disabled'], isDisabled), (0, _defineProperty2["default"])(_cn, styles['Select--negative'], hasError), _cn));
  var wrapperClassNames = (0, _classnames["default"])(styles['Select__wrapper'], styles[widthClass], className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({
    id: id,
    required: required,
    name: name,
    "aria-label": name,
    "data-test-id": testId,
    className: classNames,
    value: valueState,
    disabled: isDisabled,
    onFocus: onFocus,
    onChange: handleChange,
    onBlur: onBlur,
    onKeyDown: handleKeyDown
  }, otherProps), children), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: styles['Select__icon'],
    icon: "ArrowDown",
    color: "muted"
  }));
};

exports.Select = Select;
Select.defaultProps = defaultProps;
var _default = Select;
exports["default"] = _default;